import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { reminderTimeDropdownOptions } from "../../../../utils";

//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  addPurchaseOrder,
  updatePurchaseOrder,
} from "../../../../redux/actions/purchaseOrder";
import { getAllSkuData } from "../../../../redux/actions/skuMaster";
import {
  createAndUpdateInventoryAssignments,
  getMultipleAssignmentData,
} from "../../../../redux/actions/purchaseOrder";
import { GET_ALL_BOOKING_NAME, SET_PREVIOUS_PATH, SET_PRODUCTION_ORDER_NO } from "../../../../redux/constants";

// Component
import CreatePurchaseOrder from "./CreatePurchaseOrder";
import PurchaseOrderAssignment from "./PurchaseOrderAssignment";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import { getTemplateValuesByOrderId, uploadOrderFile } from "../../../../redux/actions/salesOrder";

function CreatePurchaseOrderTabs() {
  const navigate = useNavigate();
  const state = useLocation().state?.update;
  const allSelectedSkus = useLocation().state?.allSelectedSkus;
  const isEdited = useLocation().state?.is_edit;
  let stateTab = useLocation().state?.tab;
  stateTab = stateTab ? stateTab : 1;

  // State
  const [tab, setTab] = useState(stateTab);
  const [loader, setLoader] = useState(false);
  const [skuOptions, setSkuOptions] = useState([]);
  const [workflowLoader, setWorkflowLoader] = useState(false);
  const [newjson, setNewJson] = useState([]);
  const [validation, setValidation] = useState([]);
  const [fileupload, setFileUpload] = useState([]);
  const [upload, setUpload] = useState([]);
  //Redux
  const dispatch = useDispatch();
  const { allSkuData } = useSelector((state) => state.skuMaster);
  const purchaseOrder = useSelector(state => state.purchaseOrder);

  // Setting path for Performance Breadcrum
  useEffect(() => {
   dispatch({type: SET_PREVIOUS_PATH, payload: "/purchase_order"})
  }, [])

  useEffect(() => {
    dispatch({type: GET_ALL_BOOKING_NAME, payload: []})
  }, [])
  

  // Function to call POST API for Add Purchase Data
  const addPurchaseOrderData = () => {

    let errorArray = [];
    if(formik.values.booking_template_id){
      errorArray = newjson.map((element, index) => {
        return element.required && !element.field_value
          ? element.booking_template_custom_field_id
          : null;
      });
      setValidation(errorArray);
    }

    
    if (errorArray.some((element) => typeof element === "string")){
      return
    };

    setLoader(true);
    let payload = formik.values;

    payload['booking_fields'] = newjson;

    payload.planned_date = moment(formik.values.planned_date)
      .add(5, "hours")
      .add(30, "minutes")
      .utc()
      .format();

    const request = {
      payload,
      onSuccess: (res) => {

        if(res.status === 1){
          if (upload.length > 0) {
            let formdata = new FormData();
            for (const item of upload) {
              formdata.append("file", item);
            }
            dispatch(
              uploadOrderFile(
                "purchase_order",
                res.data.purchase_order_id,
                formdata,
                (res) => {
                  setUpload([]);
                }
              )
            );
          }

          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Purchase order created successfully.`}
                event="click"
                onClick={() => {
                  dispatch({type: GET_ALL_BOOKING_NAME, payload: []});
                  dispatch({ type: SET_PRODUCTION_ORDER_NO, payload: res.data.purchase_order_no });
                  navigate("/order/update_purchase_order", {
                    state: { update: res.data, allSelectedSkus: null, is_edit: true, tab: 2 },
                  });
                }}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          setLoader(false);
        }

        // if(res.data){
          
        //   setLoader(false);
        //   setTab(2);
        //   assignmentFormik.setFieldValue("inventory_order_id", res.data.purchase_order_id);
        //   formik.setFieldValue("sku", res.data.skus);
        // }
        setLoader(false);
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(addPurchaseOrder(request));
  };

  // Function to call PATCH API for update Purchase Order
  const updatePurchaseOrderData = () => {

    let errorArray = [];
    if(formik.values.booking_template_id){
      errorArray = newjson.map((element, index) => {
        return element.required && !element.field_value
          ? element.booking_template_custom_field_id
          : null;
      });
      setValidation(errorArray);
    }

    
    if (errorArray.some((element) => typeof element === "string")){
      return
    };


    setLoader(true);
    let payload = formik.values;
    payload['booking_fields'] = newjson;
    payload.planned_date = moment(formik.values.planned_date)
      .add(5, "hours")
      .add(30, "minutes")
      .utc()
      .format();
    const request = {
      purchase_order_id: state
        ? state.purchase_order_id
        : assignmentFormik.values.inventory_order_id,
      payload,
      onSuccess: () => {
        if (upload.length > 0) {
          let formdata = new FormData();
          for (const item of upload) {
            formdata.append("file", item);
          }
          const purchase_order_id =  state ? state.purchase_order_id : assignmentFormik.values.inventory_order_id
          dispatch(
            uploadOrderFile(
              "purchase_order",
              purchase_order_id,
              formdata,
              (res) => {
                setUpload([]);
              }
            )
          );
        }
        setLoader(false);
        setTab(2);
        // formik.resetForm();
        // navigate("/order/overview", { state: 2 });
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(updatePurchaseOrder(request));
  };
  
  useEffect(() => {

    const purchase_order_id =  state ? state.purchase_order_id : assignmentFormik.values.inventory_order_id

    if(purchase_order_id){
      dispatch(
        getTemplateValuesByOrderId(state.purchase_order_id, (res) => {
          if (res.status === 1) {
            setNewJson(res.data.controls);
            setFileUpload(res.data.file_uploads)
          }
        })
      );
    }
  }, [state, tab]);

  // Funtion to GET SKU data
  const getSKUList = () => {
    const request = {
      onError: (error) => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAllSkuData(request));
  };

  useEffect(() => {
    getSKUList();
  }, []);

  useEffect(() => {
    if (allSkuData.length > 0) {
      setSkuOptions(
        allSkuData.map((element) => {
          const obj = {
            label: element.sku_name,
            value: element.sku_master_id,
          };
          return obj;
        })
      );
    }
  }, [allSkuData]);

  const validationSchema = Yup.object().shape({
    collaborator_id: Yup.string().required("This field is required"),
    planned_date: Yup.string().required("This field is required"),
    address_line_1: Yup.string().required("This field is required"),
    address_line_2: Yup.string().nullable(),
    zip_code: Yup.string().required("This field is required"),
    city: Yup.string().required("This field is required"),
    country: Yup.string().required("This field is required"),
    purchase_order_reference_no: Yup.string().nullable(),
    sku: Yup.array().of(
      Yup.object().shape({
        sku_master_id: Yup.string().required("This field is required"),
        qty: Yup.string().required("This field is required"),
      })
    ),
    booking_template_id: Yup.string(),
    activity_assignment_id: Yup.string()
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      collaborator_id: state ? state.collaborator_id : "",
      planned_date: state ? state.planned_date : "",
      address_line_1: state ? state.address_line_1 : "",
      address_line_2: state?.address_line_2 ? state?.address_line : "",
      zip_code: state ? state.zip_code : "",
      city: state ? state.city : "",
      country: state ? state.country : "",
      booking_template_id: state ? state?.booking_template_id ? state.booking_template_id : "" : "",
      purchase_order_reference_no: state?.purchase_order_reference_no
        ? state?.purchase_order_reference_no
        : "",
      sku:
        state?.purchase_order_skus?.length > 0
          ? state.purchase_order_skus.map((item) => {
              const obj = {
                purchase_order_sku_id: item.purchase_order_sku_id,
                sku_master_id: item.sku_master_id,
                qty: item.qty,
              };
              return obj;
            })
          : allSelectedSkus?.length > 0
          ? allSelectedSkus.map((selected_item) => {
              const sku = skuOptions.find(
                (item) => item.label === selected_item
              );
              const obj = {
                sku_master_id: sku ? sku.value : "",
                qty: "",
              };
              return obj;
            })
          : [
              {
                sku_master_id: "",
                qty: "",
              },
            ],
    },
    validationSchema,
    onSubmit: () => {
      state || assignmentFormik.values.inventory_order_id
        ? updatePurchaseOrderData()
        : addPurchaseOrderData();
    },
  });

  /* ----------------------------------------------- Multiple Assignment ------------------------------------------ */

  const submitAssignment = (payload) => {

    payload['booking_fields'] = newjson;

    setLoader(true);
    const request = {
      payload,
      onSuccess: (res) => {

        setLoader(false);
        assignmentFormik.resetForm();
        formik.resetForm();
        navigate("/order/overview", { state: 2 });

        // if(res.data){
        
        //   for(const ele of res.data){
        //     if (upload.length > 0) {
        //       let formdata = new FormData();
        //       for (const item of upload) {
        //         formdata.append("file", item);
        //       }
        //       dispatch(
        //         uploadBookingFile(
        //           ele,
        //           formdata,
        //           (res) => {}
        //         )
        //       );
        //     }
        //   }
          
        // }
        
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(createAndUpdateInventoryAssignments(request));
  };

  // FUnction to GET assignment data
  const getPurchaseAssignmentData = () => {
    setWorkflowLoader(true); 
    const request = {
      inventory_order_id: state.purchase_order_id,
      inventory_order_type: assignmentFormik.values.inventory_order_type,
      onSuccess: (result) => {
        setWorkflowLoader(false);
        // console.log(result);
        const assignmentData = result.data.map((resultItem) => {
          const obj = {
            activity_assignment_id: resultItem.activity_assignment_id,
            alias: resultItem.alias,
            workflow_id: resultItem.workflow_id,
            assignments: resultItem.activity_assignment_mappings.map(
              (assignmentMappingItem) => {
                const assignmentObj = {
                  activity_assignment_mapping_id:
                    assignmentMappingItem.activity_assignment_mapping_id,
                  activity_id: assignmentMappingItem.activity_id,
                  collaborator_id: assignmentMappingItem.collaborator_id,
                  department_id: assignmentMappingItem.department_id,
                  duration: assignmentMappingItem.duration,
                  estimated_time: assignmentMappingItem.estimated_time,
                  is_mandatory: assignmentMappingItem.is_mandatory,
                  link_activity: assignmentMappingItem.link_activity,
                  loop_activity: assignmentMappingItem.loop_activity,
                  reminder_time: assignmentMappingItem.reminder_time,
                  sequence: assignmentMappingItem.sequence,
                  status: assignmentMappingItem.status,
                  user_id: assignmentMappingItem.user_id,
                  departmentSelect: "",
                  userSelect: "",
                  reminderTimeDropdownVal: "",
                };

                if(assignmentMappingItem.department) {
                    assignmentObj.departmentSelect = {
                      label: assignmentMappingItem.department.name,
                      value: assignmentMappingItem.department.id
                    }
                } else if (assignmentMappingItem.collaborator) {
                  assignmentObj.departmentSelect = {
                    label: assignmentMappingItem.collaborator.type === "collaborator" ? "Collaborator" : "Customer",
                    value: assignmentMappingItem.collaborator.type
                  }
                }

                if(assignmentMappingItem.user) {
                  assignmentObj.userSelect = {
                    label: assignmentMappingItem.user.name,
                    value: assignmentMappingItem.user.id
                  }
                } else if(assignmentMappingItem.collaborator) {
                  assignmentObj.userSelect = {
                    label: assignmentMappingItem.collaborator.name,
                    value: assignmentMappingItem.collaborator.collaborator_id
                  }
                }

                if(assignmentMappingItem.reminder_time && assignmentMappingItem.estimated_time) {
                  assignmentObj.reminderTimeDropdownVal = reminderTimeDropdownOptions.find((reminderTimeOption) => reminderTimeOption.value ===  moment(assignmentMappingItem.estimated_time).diff(
                    moment(assignmentMappingItem.reminder_time),
                    "hours"
                  ))
                }

                return assignmentObj;
              }
            ),
          };
          return obj;
        });
        assignmentFormik.setFieldValue("workflows" , assignmentData)
      },
      onError: (error) => {
        setWorkflowLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getMultipleAssignmentData(request));
  };

  const assignmentFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      inventory_order_id: "",
      inventory_order_type: "purchase_order",
      booking_template_id: "",
      workflows: [
        {
          workflow_id: null,
          //activity_assignment_id: "", // used while updating assignment
          alias: "", // assignment_name
          assignments: [],
        },
      ],
    },
    onSubmit: (value) => {
      const payload = {
        inventory_order_id: value.inventory_order_id,
        inventory_order_type: value.inventory_order_type,
        booking_template_id: value.booking_template_id,
        workflows: value.workflows.map((workflowData) => {
          const obj = {
            ...workflowData,
            assignments: workflowData.assignments.map(
              (assignmentItem, index) => {
                const assignmentObj = {
                  ...assignmentItem,
                  sequence: index + 1,
                  reminder_time: assignmentItem.reminder_time
                    ? new Date(assignmentItem.reminder_time).toISOString()
                    : null,
                };

                delete assignmentObj.userSelect;
                delete assignmentObj.departmentSelect;
                delete assignmentObj.reminderTimeDropdownVal;

                return assignmentObj;
              }
            ),
          };
          return obj;
        }),
      };
      submitAssignment(payload);
    },
  });

  useEffect(() => {
    if (state) {
      assignmentFormik.setFieldValue(
        "inventory_order_id",
        state.purchase_order_id
      );
    }

    if (tab === 2 && state) {
      getPurchaseAssignmentData();
    }
  }, [state, tab]);

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <div className="flex items-end space-x-4">
        <ul
          className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12 grow w-full"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="text-left flex items-center space-x-2">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 1 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(1)}
            >
              Basic Details
            </a>
          </li>
          <li className="text-left flex items-center space-x-2">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 ${
                state || assignmentFormik.values.inventory_order_id
                  ? "cursor-pointer"
                  : "pointer-events-none"
              } cursor-pointer ${
                tab === 2 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(2)}
            >
              Workflows
            </a>
          </li>
        </ul>
        <div className="flex justify-end items-center space-x-4">
          <button
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
            onClick={() => {
              navigate("/order/overview", { state: 2 });
              formik.resetForm();
              assignmentFormik.resetForm();
            }}
          >
            Cancel
          </button>
          <button
            className="btn !bg-[--bg-color-500] hover:bg-[--bg-color-600] text-white cursor-pointer w-48"
            type="submit"
            onClick={() => {
              if (tab === 1) {
                formik.handleSubmit();
              } else {
                assignmentFormik.handleSubmit();
              }
            }}
          >
            {loader ? (
              <svg
                className="animate-spin w-5 h-45 fill-current shrink-0"
                viewBox="0 0 16 16"
              >
                <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
              </svg>
            ) : state ? (
              "Update Purchase Order"
            ) : (
              "Create Purchase Order"
            )}
          </button>
        </div>
      </div>
      {tab === 1 && (
        <CreatePurchaseOrder
          formik={formik}
          skuOptions={skuOptions}
          newjson={newjson}
          setNewJson={setNewJson}
          validation={validation}
          fileupload={fileupload}
          setFileUpload={setFileUpload}
          upload={upload}
          setUpload={setUpload}
          assignmentFormik={assignmentFormik}
          isEdited={isEdited}
        />
      )}
      {tab === 2 && (
        <PurchaseOrderAssignment
          assignmentFormik={assignmentFormik}
          workflowLoader={workflowLoader}
        />
      )}
    </div>
  );
}

CreatePurchaseOrderTabs.auth = {
  path: "/order/create_purchase_order",
  role: "super-admin admin",
};

export default CreatePurchaseOrderTabs;
